// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceExtendedSettingsEditController = function ($scope, $http) {
    $http({
        method: "GET",
        url: "/api/v1/legalEntity/isExtendedLineItemInformation",
        params: null,
        data: null,
        headers: {},
        cache: false
    }).then(function (response) {
        $scope.showExtendedBookedQuantityInfo = response.data;
    });

    $scope.save = function () {
        $http({
            method: "POST",
            url: "/api/v1/legalEntity/isExtendedLineItemInformation",
            params: { showBookedQuantityExtendedInformation: $scope.showExtendedBookedQuantityInfo },
            data: {},
            headers: {},
            cache: false
        }).then(function() {
            $scope.notifySuccess();
        });
    }
};
InvoiceExtendedSettingsEditController.$inject = ['$scope', '$http'];
